// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* figure, */
figure.oxzion-widget,
div.oxzion-widget {
  text-align: center;
  outline: solid 1px #ccc;
  background: rgba(0, 0, 0, 0.05);
  margin: 10px 20px;
  display: inline-block;
  position: relative;
}

/* figure > figcaption, */
figure.oxzion-widget > figcaption {
  text-align: center;
  /* display:block; */
  display: none;
}

figure.oxzion-widget > div.oxzion-widget-roll-up-button,
div.oxzion-widget > div.oxzion-widget-roll-up-button {
  z-index: 2;
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 30px;
  margin: 10px;
  cursor: pointer;
}

.oxzion-widget-content {
  position: relative;
}

div > div.oxzion-widget-drilldown-icon {
  top: 20px;
  position: absolute;
  z-index: 3;
  cursor: pointer;
  color: #265160;
  right: 3px;
}

div > div.oxzion-widget-drilldown-table-icon {
  color: #265160;
  z-index: 3;
  position: relative;
  float: right;
  top: 20px;
  margin-right: 10px;
  margin-left: 12px;
}

.oxzion-widget-grid-button {
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 5px;
}

.oxzion-widget-aggregate-drilldown {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}

.red {
  color: #EE4424;
  font-weight: bold;
}

.green {
  color: #A3C53A;
  font-weight: bold;
}

.yellow {
  color: #F3BA1D;
  font-weight: bold;
}

/* This is to make the header same as the headers in the app builder appa list view.*/
/* .oxzion-widget [role="columnheader"] {
    border: 0;
    border-width: 0;
    border-color: transparent;
} */`, "",{"version":3,"sources":["webpack://./../gui/src/components/OI/WidgetStyles.css"],"names":[],"mappings":"AAAA,YAAA;AACA;;EAGI,kBAAA;EACA,uBAAA;EACA,+BAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AAAJ;;AAGA,yBAAA;AACA;EAEI,kBAAA;EACA,mBAAA;EACA,aAAA;AADJ;;AAIA;;EAEI,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,SAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AADJ;;AAIA;EACI,cAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,aAAA;EACA,2BAAA;EACA,kBAAA;AADJ;;AAIA;EACI,0BAAA;EACA,WAAA;EACA,eAAA;AADJ;;AAIA;EACI,cAAA;EACA,iBAAA;AADJ;;AAIA;EACI,cAAA;EACA,iBAAA;AADJ;;AAIA;EACI,cAAA;EACA,iBAAA;AADJ;;AAKA,qFAAA;AACA;;;;GAAA","sourcesContent":["/* figure, */\nfigure.oxzion-widget,\ndiv.oxzion-widget\n{\n    text-align:center;\n    outline:solid 1px #ccc;\n    background:rgba(0,0,0,0.05);\n    margin:10px 20px;\n    display:inline-block;\n    position:relative;\n}\n\n/* figure > figcaption, */\nfigure.oxzion-widget > figcaption\n{\n    text-align:center;\n    /* display:block; */\n    display:none;\n}\n\nfigure.oxzion-widget > div.oxzion-widget-roll-up-button, \ndiv.oxzion-widget > div.oxzion-widget-roll-up-button {\n    z-index:2;\n    position:absolute;\n    top:0px;\n    right:0px;\n    font-size:30px;\n    margin:10px;\n    cursor:pointer;\n}\n\n.oxzion-widget-content {\n    position: relative;\n}\n\ndiv > div.oxzion-widget-drilldown-icon{\n    top: 20px;\n    position: absolute;\n    z-index: 3;\n    cursor: pointer;\n    color: #265160;\n    right: 3px; \n}\n\ndiv > div.oxzion-widget-drilldown-table-icon{\n    color: #265160;\n    z-index: 3;\n    position: relative;\n    float: right;\n    top: 20px;\n    margin-right: 10px;\n    margin-left: 12px;\n}\n\n.oxzion-widget-grid-button{\n    display: flex;\n    flex-direction: row-reverse;\n    margin-bottom: 5px;\n}\n\n.oxzion-widget-aggregate-drilldown{\n    text-decoration: underline;\n    color: blue;\n    cursor: pointer;\n}\n\n.red {\n    color: #EE4424;\n    font-weight: bold;\n}\n\n.green {\n    color:#A3C53A;\n    font-weight: bold;\n}\n\n.yellow {\n    color: #F3BA1D;\n    font-weight: bold;\n}\n\n\n/* This is to make the header same as the headers in the app builder appa list view.*/\n/* .oxzion-widget [role=\"columnheader\"] {\n    border: 0;\n    border-width: 0;\n    border-color: transparent;\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
